<ng-container *transloco="let t; read: 'settings'">
    <div class="componentContainer">
      <section class="xs12col componentHeader">
          <h1>{{t('title')}}</h1>
      </section>
  
      <section class="oneCol">
        <div class="xs12col">
          <div class="boxContainer">
            <div class="box margin-bottom-medium">
              <a [routerLink]="['device-categories']">{{t('deviceCategories.title')}}</a>
            </div>
            <div class="box margin-bottom-medium">
              <a [routerLink]="['device-manufacturers']">{{t('deviceManufacturer.title')}}</a>
            </div>
            <div class="box margin-bottom-medium">
              <a [routerLink]="['wearing-part-categories']">{{t('wearingPartCategories.title')}}</a>
            </div>
            <div class="box margin-bottom-medium">
              <a [routerLink]="['revision-status']">{{t('revisionStatus.title')}}</a>
            </div>
            <!--
            <div class="box">
              <a href="/">{{t('ticketStatus.title')}}</a>
            </div>
            -->
            <!--
            <div class="box">
              <a href="/">{{t('revisionStatus.title')}}</a>
            </div>
            -->
          </div>
        </div>
      </section>
    </div>
  </ng-container>
  